'use client';

import React from 'react';
import { SignUpProviders } from '@/components/Auth/SignUp/SignUp';
import { Providers } from '@/components/Auth/utils';

export const SignUp = ({
  callbackURL,
  isPREval,
}: {
  callbackURL?: string;
  isPREval?: boolean;
}) => {
  let providers: Providers[] = [
    'github',
    'gitlab',
    'gitlab-self-hosted',
    'bitbucket',
  ];
  if (isPREval) {
    providers = ['github'];
  }

  return (
    <SignUpProviders
      providers={providers}
      isPopUp={false}
      callbackUrl={callbackURL}
    />
  );
};
